import { render } from "./editTask.vue?vue&type=template&id=a38af2a8"
import script from "./editTask.vue?vue&type=script&lang=js"
export * from "./editTask.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__